import React from 'react';

export default function Error500() {
  return (
    <h1>
      Internal server error 500
    </h1>
  );
}
